<script lang="ts" setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import ImpersonationInfo from "@/shared/components/ImpersonationInfo/ImpersonationInfo.vue";
import {
  clearImpersonationCookie,
  getImpersonatedUserIdFromCookie,
} from "@/shared/helper/impersonationCookie.helper";

const route = useRoute();
const impersonatedUserId = ref(getImpersonatedUserIdFromCookie());

watch(
  () => route.fullPath,
  () => {
    impersonatedUserId.value = getImpersonatedUserIdFromCookie();
  },
);
const stopImpersonation = () => {
  clearImpersonationCookie();
  window.location.href = `/${AppIdentifier.Dashboard}`;
};
</script>

<template>
  <ImpersonationInfo
    v-if="impersonatedUserId"
    :user-id="impersonatedUserId"
    @stop-impersonation="stopImpersonation"
  />
</template>
